export enum WatchProvider {
  AMAZON_PRIME = 'Amazon Prime Video',
  AMAZON_PRIME_WITH_ADS = 'Amazon Prime Video with Ads',
  AMAZON_VIDEO = 'Amazon Video',
  APPLE_ITUNES = 'Apple iTunes',
  APPLE_TV = 'Apple TV',
  ARROW = 'ARROW',
  ARROW_VIDEO_AMAZON_CHANNEL = 'Arrow Video Amazon Channel',
  BBC_IPLAYER = 'BBC iPlayer',
  BFI_PLAYER = 'BFI Player',
  BRITBOX_AMAZON_CHANNEL = 'BritBox Amazon Channel',
  CHANNEL_4 = 'Channel 4',
  CHILI = 'Chili',
  CURZON_HOME_CINEMA = 'Curzon Home Cinema',
  DISNEY_PLUS = 'Disney Plus',
  GOOGLE_PLAY_MOVIES = 'Google Play Movies',
  IMDB_TV_AMAZON_CHANNEL = 'IMDB TV Amazon Channel',
  MGM_PLUS_AMAZON_CHANNEL = 'MGM Plus Amazon Channel',
  MICROSOFT_STORE = 'Microsoft Store',
  NETFLIX = 'Netflix',
  NETFLIX_WITH_BASIC_ADS = 'Netflix basic with Ads',
  NOW_TV_CINEMA = 'Now TV Cinema',
  PARAMOUNT_PLUS = 'Paramount Plus',
  PARAMOUNT_PLUS_AMAZON_CHANNEL = 'Paramount+ Amazon Channel',
  PARAMOUNT_PLUS_APPLE_TV_CHANNEL = 'Paramount Plus Apple TV Channel',
  PLEX = 'Plex',
  PLUTO_TV = 'Pluto TV',
  RAKUTEN_TV = 'Rakuten TV',
  SHUDDER = 'Shudder',
  SHUDDER_AMAZON_CHANNEL = 'Shudder Amazon Channel',
  SKY_GO = 'Sky Go',
  SKY_STORE = 'Sky Store',
  VIRGIN_TV_GO = 'Virgin TV Go',
  YOUTUBE = 'YouTube',
}

export const watchProviderLinks = {
  [WatchProvider.AMAZON_PRIME]: 'https://www.amazon.co.uk/gp/video/storefront',
  [WatchProvider.AMAZON_PRIME_WITH_ADS]: 'https://www.amazon.co.uk/gp/video/storefront',
  [WatchProvider.AMAZON_VIDEO]: 'https://www.amazon.co.uk/Amazon-Video/b?node=3010085031',
  [WatchProvider.APPLE_ITUNES]: 'https://tv.apple.com/',
  [WatchProvider.APPLE_TV]: 'https://tv.apple.com/',
  [WatchProvider.ARROW]: 'https://www.arrow-player.com/',
  [WatchProvider.ARROW_VIDEO_AMAZON_CHANNEL]:
    'https://www.amazon.co.uk/Movies-Arrow-Video-Prime/s?rh=n%3A3046737031%2Cp_n_subscription_id%3A12464071031',
  [WatchProvider.BBC_IPLAYER]: 'https://www.bbc.co.uk/iplayer',
  [WatchProvider.BFI_PLAYER]: 'https://player.bfi.org.uk/',
  [WatchProvider.BRITBOX_AMAZON_CHANNEL]: 'https://www.amazon.co.uk/gp/video/storefront/subscription/britboxuk',
  [WatchProvider.CHANNEL_4]: 'https://www.channel4.com/',
  [WatchProvider.CHILI]: 'https://chili.com/',
  [WatchProvider.CURZON_HOME_CINEMA]: 'https://homecinema.curzon.com/',
  [WatchProvider.DISNEY_PLUS]: 'https://www.disneyplus.com/',
  [WatchProvider.GOOGLE_PLAY_MOVIES]: 'https://play.google.com/store/movies',
  [WatchProvider.IMDB_TV_AMAZON_CHANNEL]: 'https://www.amazon.co.uk/adlp/imdbtv-about',
  [WatchProvider.MGM_PLUS_AMAZON_CHANNEL]: 'https://www.amazon.co.uk/gp/video/offers?benefitId=mgm',
  [WatchProvider.MICROSOFT_STORE]: 'https://www.microsoft.com/store/movies-and-tv',
  [WatchProvider.NETFLIX]: 'https://www.netflix.com',
  [WatchProvider.NETFLIX_WITH_BASIC_ADS]: 'https://www.netflix.com',
  [WatchProvider.NOW_TV_CINEMA]: 'https://www.nowtv.com/stream/most-popular',
  [WatchProvider.PARAMOUNT_PLUS]: 'https://www.paramountplus.com/',
  [WatchProvider.PARAMOUNT_PLUS_AMAZON_CHANNEL]: 'https://www.amazon.co.uk/paramount-plus/s?k=paramount+plus',
  [WatchProvider.PARAMOUNT_PLUS_APPLE_TV_CHANNEL]: 'https://www.paramountplus.com/',
  [WatchProvider.PLEX]: 'https://www.plex.tv/',
  [WatchProvider.PLUTO_TV]: 'https://pluto.tv/',
  [WatchProvider.RAKUTEN_TV]: 'https://rakuten.co.uk/rakuten-tv',
  [WatchProvider.SHUDDER]: 'https://www.shudder.com/',
  [WatchProvider.SHUDDER_AMAZON_CHANNEL]:
    'https://www.amazon.co.uk/Prime-Video-Shudder/s?rh=n%3A3010085031%2Cp_n_subscription_id%3A12464107031',
  [WatchProvider.SKY_GO]: 'https://www.sky.com/watch/sky-go/',
  [WatchProvider.SKY_STORE]: 'https://www.skystore.com/',
  [WatchProvider.VIRGIN_TV_GO]: 'https://virgintvgo.virginmedia.com/en/movies-and-series/movies1.html',
  [WatchProvider.YOUTUBE]: 'https://www.youtube.com/feed/storefront',
};
